/**
 * Removes punctuation characters from search string
 * Keeps only alphanumeric characters and spaces
 * @param searchTerm - The search string to sanitize
 * @returns Sanitized search string without punctuation
 */
export const sanitizeSearchTerm = (searchTerm: string): string => {
  if (!searchTerm || typeof searchTerm !== 'string') {
    return '';
  }

  // Remove all punctuation characters (dots, slashes, hashes, etc.)
  // Keep only letters, numbers, and spaces
  return searchTerm.replace(/[^\w\s]/g, '').trim();
};
